import type { ResourcesConfig } from "aws-amplify";

const defaultRedirectOrigins = import.meta.env.PROD
	? ["https://signaloid.io"]
	: ["https://localhost:3000", "https://cpu1.signaloid.dev", "https://signaloid.io"];

const customerDomainOrigin = import.meta.env.PROD
	? /^https:\/\/[a-z0-9-]+\.signaloid\.io$/
	: /^https:\/\/[a-z0-9-]+\.signaloid\.dev$/;

function currentCustomerDomainOrigin(): string[] {
	const origin = typeof window === "undefined" ? "" : window.location.origin;
	return customerDomainOrigin.test(origin) && !defaultRedirectOrigins.includes(origin) ? [origin] : [];
}

const redirectOrigins = [...defaultRedirectOrigins, ...currentCustomerDomainOrigin()];

export const AwsConfig: ResourcesConfig = {
	Auth: {
		Cognito: {
			userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? "",
			userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_APP_ID ?? "",
			loginWith: {
				oauth: {
					domain: import.meta.env.VITE_COGNITO_OAUTH_DOMAIN ?? "",
					scopes: ["openid", "email", "profile", "aws.cognito.signin.user.admin"],
					redirectSignIn: redirectOrigins,
					redirectSignOut: redirectOrigins.map((origin) => `${origin}/login`),
					responseType: "code",
					providers: ["Google"],
				},
			},
		},
	},
};
